import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useStyles } from '@unicat/CakePageContent/styles';
import ImageWrapper from '@unicat/UI/ImageWrapper';
import { propTypes as CakesPropTypes } from '@config/Validators/cake.validator';

const CakeImage = ({ image: { id, imgLink, images }, interval = 10000, duration = 1500 }) => {
  const classes = useStyles();

  if (typeof imgLink === 'undefined') {
    imgLink = [];
    images.forEach((/*img*/) => {
      imgLink.push({});
    });
  }

  const [nextImage, setNextImage] = useState(null);

  /* change image with an interval */
  useEffect(() => {
    let int;
    int = setInterval(() => {
      if (!nextImage) {
        setNextImage(imgLink[1] ?? imgLink[0]);
      } else {
        setNextImage((prevState) => {
          const now = imgLink.indexOf(prevState);
          return imgLink[now >= 0 ? (now < imgLink.length - 1 ? now + 1 : 0) : 0];
        });
      }
    }, interval);

    return () => clearInterval(int);
  }, []);

  return (
    <>
      <div className={classes.card}>
        <ImageWrapper alt={id} src={imgLink[0]} duration={duration} nextImage={nextImage} hoverable={false} />
      </div>
    </>
  );
};

CakeImage.defaultProps = {
  interval: 10000,
  duration: 1500,
};

const imagePropTypes = { ...CakesPropTypes };
CakeImage.propTypes = {
  image: PropTypes.shape(imagePropTypes).isRequired,
  hovered: PropTypes.bool,
  interval: PropTypes.number,
  duration: PropTypes.number,
};

export default CakeImage;
